/**
 * Modal triggers.
 *
 * Usage:
 * <button type="button" data-modal="#quote">Soumission</button>
 * <a href="#quote" data-modal="#quote">Soumission</a>
 */

const modalTriggers = document.querySelectorAll('[data-modal]');
const modalCloseTriggers = document.querySelectorAll('[data-modal-close]');

function openModal(modal) {
  if (!modal) {
    return;
  }

  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.classList.add('overflow-hidden');
}

function closeModal(modal) {
  if (!modal) {
    return;
  }

  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('overflow-hidden');
}

function closeAllModals() {
  document.querySelectorAll('.site-modal.is-open').forEach(modal => {
    closeModal(modal);
  });
}

modalTriggers.forEach(trigger => {
  trigger.addEventListener('click', event => {
    event.preventDefault();

    const modalSelector = trigger.dataset.modal;
    const modal = document.querySelector(modalSelector);

    openModal(modal);
  });
});

modalCloseTriggers.forEach(trigger => {
  trigger.addEventListener('click', () => {
    const modal = trigger.closest('.site-modal');

    closeModal(modal);
  });
});

document.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
    closeAllModals();
  }
});